import { Button, Col, Divider, Form, Input, Row, Select, Space, Image, Checkbox, Flex } from "antd";
import { useEffect, useRef, useState } from "react";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { CheckOutlined, LeftOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import { buscarCep } from "../../../../services/localizacaoService";
import { MaskedInput } from "antd-mask-input";
import { mascaraCep } from "../../../../util/mascaras";
import { ConsignatarioModel } from "../../../../models/consignatario/consignatarioModel";
import { atualizarConsignatario } from "../../../../services/consiganatarioService";
import { setPageConsignatario } from "../../../../redux/slices/consignatario/consignatarioSlice";
import { EstadoModel } from "../../../../models/localizacao/estadoModel";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";

const CadastrarPage = () => {
  //estados globais
  const localizacaoState = useAppSelector((state) => state.localizacao);
  const consignatarioState = useAppSelector((state) => state.consignatario);
  const empresaState = useAppSelector((state) => state.empresa);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const [inputCep, setInputCep] = useState<string>("");
  const [ehCNPJ, setEhCNPJ] = useState(true);
  const [gerarDados, setGerarDados] = useState(false);

  const inputInicial = useRef<any>(null);
  const inputNumero = useRef<any>(null);

  const editar = Object.values(consignatarioState.entity).length !== 0;

  useEffect(() => {
    if (inputInicial.current && !editar) {
      inputInicial.current.focus();
    }
    if (editar) {
      dispatch(setTitle("EDITAR CONSIGNATÁRIO"));
      setGerarDados(consignatarioState.entity.emailConsignatario !== null ? true : false);
      form.setFieldsValue({ ...consignatarioState.entity, cep: consignatarioState.entity.cep?.replace(/^(\d{5})(\d)/, "$1-$2"), uf: consignatarioState.entity.idEstado });
      setEhCNPJ(consignatarioState.entity?.cpfcnpj?.length > 11);
      setInputCep(consignatarioState.entity.cep?.replace(/^(\d{5})(\d)/, "$1-$2"));
    } else {
      dispatch(setTitle("NOVO CONSIGNATÁRIO"));
      setGerarDados(false);
    }
  }, [consignatarioState.entity]);

  const submit = async (value: any) => {
    if (editar) {
      const editarConsignatario: ConsignatarioModel = { ...value };
      editarConsignatario.ativo = consignatarioState.entity.ativo;
      editarConsignatario.homepage = consignatarioState.entity.homepage;
      editarConsignatario.idUsuario = consignatarioState.entity.idUsuario;
      editarConsignatario.idPessoa = consignatarioState.entity.idPessoa;
      editarConsignatario.tipoPessoa = "PF";
      editarConsignatario.idPais = consignatarioState.entity.idPais;
      editarConsignatario.id = consignatarioState.entity.id;
      editarConsignatario.cep = value.cep?.replace(/[^0-9]/g, "");
      editarConsignatario.cpfcnpj = value.cpfcnpj?.replace(/[^0-9]/g, "");
      editarConsignatario.idEstado = value.idEstado;
      dispatch(atualizarConsignatario({ value: editarConsignatario, busca: consignatarioState.busca }));
    }
  };

  const onBuscarCep = async () => {
    const retorno = await dispatch(buscarCep(inputCep?.replace(/[^0-9]/g, "")));
    form.setFieldsValue({
      endereco: retorno.payload.logradouro,
      bairro: retorno.payload.bairro,
      cidade: retorno.payload.localidade,
      idEstado: localizacaoState.listEstado.filter((a: EstadoModel) => a.sigla === retorno.payload.uf)[0].id,
    });
    inputNumero.current.focus();
  };

  const changeCPF = (cpf: string) => {
    let soNumeros = cpf.replace(/[^0-9]/g, "");
    if (soNumeros?.length >= 11) {
      setEhCNPJ(true);
    } else {
      setEhCNPJ(false);
    }
  };

  const handleGerar = (e: any) => {
    setGerarDados(e.target.checked);
  };

  const voltar = () => {
    dispatch(setPageConsignatario("geral"));
  };

  return (
    <Flex vertical>
      <Flex onClick={voltar} className="voltar">
        {"<"} VOLTAR
      </Flex>
      <Form form={form} layout="vertical" onFinish={submit}>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              label="Razão Social"
              name="razaoSocial"
              rules={[
                {
                  required: true,
                  message: "Digite a razão social",
                },
              ]}
            >
              <Input type="text" ref={inputInicial} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Nome Fantasia"
              name="apelido"
              rules={[
                {
                  required: true,
                  message: "Digito o nome fantasia da empresa",
                },
              ]}
            >
              <Input type="text" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={8}>
            <Form.Item
              label="Empresa"
              name="idEmpresa"
              rules={[
                {
                  required: true,
                  message: "Selecione uma empresa",
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="labelSearch"
                placeholder="Selecione uma empresa"
                loading={empresaState.loading}
                style={{ width: "100%" }}
                options={empresaState.list.map((a: EmpresaModel) => ({
                  value: a.id,
                  key: a.apelido,
                  label: (
                    <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                      <div style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</div>
                      {a.apelido}
                    </Flex>
                  ),
                  labelSearch: a.apelido,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="CPF/CNPJ"
              name="cpfcnpj"
              rules={[
                {
                  required: true,
                  message: "Digite a razão social",
                },
              ]}
            >
              {ehCNPJ ? (
                <MaskedInput onKeyUp={(event) => changeCPF((event as any).target.value)} mask="00.000.000/0000-00"></MaskedInput>
              ) : (
                <MaskedInput onKeyUp={(event) => changeCPF((event as any).target.value)} mask="000.000.000-00"></MaskedInput>
              )}
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Identidade" name="identidade">
              <Input type="text" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Orgão emissor" name="orgaoEmissor">
              <Input type="text" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={8}>
            <Form.Item label="Inscrição Estadual" name="inscricaoEstadual">
              <Input type="text" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Inscrição Municipal" name="inscricaoMunicipal">
              <Input type="text" />
            </Form.Item>
          </Col>
        </Row>
        {editar ? (
          <></>
        ) : (
          <>
            <Divider orientation="left" orientationMargin="0">
              Dados de acesso
            </Divider>
            <Row gutter={12}>
              <Col>
                <Form.Item label="" name="geraContaFinanceira" valuePropName="checked">
                  <Checkbox onChange={handleGerar}>Gerar dados de acesso ao sistema</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            {gerarDados ? (
              <>
                <Row gutter={12}>
                  <Col span={8}>
                    <Form.Item label="E-mail" name="emailConsignatario">
                      <Input type="text" />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Senha" name="password">
                      <Input type="password" placeholder="Digite sua senha" />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            ) : (
              <></>
            )}
          </>
        )}
        <Divider orientation="left" orientationMargin="0">
          Endereço
        </Divider>
        <Row gutter={12}>
          <Col flex="auto" span={6}>
            <Form.Item label="CEP" name="cep">
              <MaskedInput defaultValue={consignatarioState.entity.cep?.replace(/^(\d{5})(\d)/, "$1-$2") || undefined} mask={mascaraCep()} onChange={(e) => setInputCep(e.target.value)} />
            </Form.Item>
          </Col>
          <Col className="colCepButton">
            <Form.Item label=" ">
              <Button className="cepButton" onClick={onBuscarCep}>
                Buscar
              </Button>
            </Form.Item>
          </Col>
          <Col flex="auto" span={14}>
            <Form.Item label="Logradouro" name="endereco">
              <Input type="text" />
            </Form.Item>
          </Col>
          <Col flex="auto" span={4}>
            <Form.Item label="Número" name="numero">
              <Input type="text" ref={inputNumero} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col flex="auto" span={6}>
            <Form.Item label="Complemento" name="complemento">
              <Input type="text" />
            </Form.Item>
          </Col>
          <Col flex="auto" span={8}>
            <Form.Item label="Bairro" name="bairro">
              <Input type="text" />
            </Form.Item>
          </Col>
          <Col flex="auto" span={8}>
            <Form.Item label="Cidade" name="cidade">
              <Input type="text" />
            </Form.Item>
          </Col>
          <Col flex="auto" span={2}>
            <Form.Item label="UF" name="idEstado">
              <Select
                autoFocus
                showSearch
                optionFilterProp="label"
                loading={localizacaoState.loadingEstado}
                options={localizacaoState.listEstado.map((a: any) => ({
                  value: a.id,
                  label: a.sigla,
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col flex="auto" span={24}>
            <Form.Item label="Observação" name="observacao">
              <TextArea rows={3} />
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Row gutter={12}>
          <Col span={24} className="modalFooter">
            <Space size="middle">
              <Button className="cancelButton" onClick={voltar} icon={<LeftOutlined />}>
                FECHAR
              </Button>
              <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
                {editar ? "ATUALIZAR" : "SALVAR"}
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Flex>
  );
};

export default CadastrarPage;
